<label [attr.for]="formControlName" class="form-label {{isRequired()?'required':''}}">{{ label }}</label>
<div class="input-group flex-nowrap">
  <input [type]="type" class="form-control" [id]="formControlName" [formControl]="control" [readonly]="isReadOnly" autocomplete="off">
  <span class="input-group-text" id="addon-wrapping">%</span>
</div>
<form-field-error [form-control]="control"></form-field-error>
